import type { ComparisonRow } from "./comparison-table";

export const COMPARISON_ROWS: ComparisonRow[] = [
  { label: "Brand",       accessor: (p) => p.brand?.name },
  { label: "Category",    accessor: (p) => p.category?.name },
  { label: "Description", accessor: (p) => p.description },
  { label: "SKU",         accessor: (p) => p.defaultCode },
  { label: "Warranty",    accessor: (p) => p.warranty?.name },
];
